import { removeStyleTag, upsertStyleTag } from "../../domStyles";

let readingGuideEl: HTMLDivElement | null = null;
let onReadingGuideMove: ((e: MouseEvent) => void) | null = null;

const GUIDE_ID = "incluway-reading-guide";
const STYLE_ID = "incluway-reading-guide-style";
const CURSOR_CLASS = "incluway-reading-guide-active";

function ensureReadingGuideStyle() {
  upsertStyleTag(
    STYLE_ID,
    `
html.${CURSOR_CLASS},
html.${CURSOR_CLASS} * {
  cursor: none !important;
}

#${GUIDE_ID} {
  position: fixed;
  left: 0;
  top: -9999px;
  z-index: 2147483647;
  pointer-events: none;
  will-change: transform, width, left, top;
  transform: translateZ(0);
}

#${GUIDE_ID} .incluway-reading-guide__bar {
  position: relative;
  width: 100%;
  height: 7px;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.12) 0%,
      rgba(0, 0, 0, 0.72) 14%,
      rgba(0, 0, 0, 0.96) 50%,
      rgba(0, 0, 0, 0.72) 86%,
      rgba(0, 0, 0, 0.12) 100%
    );
  box-shadow:
    0 2px 10px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.04);
}

#${GUIDE_ID} .incluway-reading-guide__bar::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 14px;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.2);
}
`.trim(),
  );
}

function ensureReadingGuide() {
  if (readingGuideEl) return;

  ensureReadingGuideStyle();

  readingGuideEl = document.createElement("div");
  readingGuideEl.id = GUIDE_ID;
  readingGuideEl.innerHTML = `<div class="incluway-reading-guide__bar"></div>`;

  document.body.appendChild(readingGuideEl);
}

export function enableReadingGuide() {
  ensureReadingGuide();
  document.documentElement.classList.add(CURSOR_CLASS);

  if (!onReadingGuideMove) {
    onReadingGuideMove = (e: MouseEvent) => {
      if (!readingGuideEl) return;

      const preferredWidth = 380;
      const minWidth = 140;
      const offsetY = 14;
      const sidePadding = 12;
      const guideHeight = 7;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const availableLeft = e.clientX - sidePadding;
      const availableRight = viewportWidth - e.clientX - sidePadding;
      const maxSymmetricWidth = Math.min(availableLeft, availableRight) * 2;

      const width = Math.max(
        minWidth,
        Math.min(preferredWidth, maxSymmetricWidth),
      );

      let left = e.clientX - width / 2;
      if (left < sidePadding) left = sidePadding;
      if (left + width > viewportWidth - sidePadding) {
        left = viewportWidth - sidePadding - width;
      }

      let top = e.clientY + offsetY;
      const maxTop = viewportHeight - guideHeight - sidePadding;

      if (top > maxTop) {
        top = e.clientY - offsetY - guideHeight;
      }

      if (top < sidePadding) {
        top = sidePadding;
      }

      readingGuideEl.style.width = `${Math.round(width)}px`;
      readingGuideEl.style.left = `${Math.round(left)}px`;
      readingGuideEl.style.top = `${Math.round(top)}px`;
    };

    document.addEventListener("mousemove", onReadingGuideMove, true);
  }
}

export function disableReadingGuide() {
  if (onReadingGuideMove) {
    document.removeEventListener("mousemove", onReadingGuideMove, true);
    onReadingGuideMove = null;
  }

  document.documentElement.classList.remove(CURSOR_CLASS);

  readingGuideEl?.remove();
  readingGuideEl = null;

  removeStyleTag(STYLE_ID);
}
